export default __webpack_public_path__ + "static/OptimaNovaLTProLight-4a7407e205649ff8cd09c747b1eeae95.ttf";